import React from 'react';
import { copyFor } from 'config';
import { Card, Container, InvisibleHeading } from 'styles';
import { LoadingModule } from 'components/loading';
import { CardContent } from 'components/errors/content/content.style';
import { ErrorText } from 'components/errors/content';
import { NotificationCard } from './notification-card';
import { Carousel } from './carousel';

interface Props {
  notifications: QueriedNotification[];
  isSMB: boolean;
  isloading: boolean;
  isError: boolean;
}

const getCopy = copyFor('dashboard.standardDashboard.notifications');

export const Notifications = ({
  notifications,
  isSMB,
  isloading,
  isError,
}: Props) => {
  const invisibleHeading = (
    <InvisibleHeading tag="h2">{getCopy('accessibleTitle')}</InvisibleHeading>
  );

  if (isError) {
    return (
      <Card mobileVariant="flat" style={{ marginBottom: '24px' }}>
        <CardContent
          variant="primary"
          data-testid="notifications-error-content"
          style={{ padding: '24px', borderRadius: '8px' }}
        >
          <Container flex direction="column" alignItems="center">
            <ErrorText variant="primary" />
          </Container>
        </CardContent>
      </Card>
    );
  }

  if (isloading) {
    return (
      <div style={{ marginBottom: '24px' }}>
        <LoadingModule variant="generic" />
      </div>
    );
  } else if (notifications.length === 0) {
    return null;
  } else if (notifications.length === 1) {
    return (
      <>
        {invisibleHeading}
        <NotificationCard notification={notifications[0]} isSMB={isSMB} />
      </>
    );
  } else {
    return (
      <>
        {invisibleHeading}
        <Carousel notifications={notifications} isSMB={isSMB} />
      </>
    );
  }
};
